import React, { Component } from 'react';
import { Card, CardBody, Col, Container, Row, Table } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';

import Breadcrumb from '../../common/components/Breadcrumb';
import i18n from '../../i18n';
import ClipboardButton from '../../common/cellData/CopyButton';
import {DATE_FORMAT, getGuidShortFormat} from '../../common/utils/common';
import CustomPagination from '../../common/tables/CustomPagination';

import './workflow.scss';

import mockData from './automation-mock-list.json';
import close_2 from '../../assets/images/common/Group 10873_1.svg';
import NewCustomTable from '../../components/NewCustomTable';
import MetaTags from 'react-meta-tags';

function WorkflowStatus({ status }) {
    return <span className={`automation-list-status ${status}`}>{status}</span>;
}

function WorkflowTable({ list }) {
    const columns = [
        { label: i18n.t('workflow.workflowId') },
        { label: i18n.t('workflow.createdTime') },
        { label: i18n.t('workflow.lastUpdated') },
        { label: i18n.t('workflow.name') },
        { label: i18n.t('workflow.status') }
    ];

    return (
        <NewCustomTable columns={columns}>
            {list.map((item, index) => (
                <tr key={index} className="text-center">
                    <td>
                        <Link
                            to={`/workflow/${item.id}`}
                            className="me-2 app-text-primary"
                        >
                            {getGuidShortFormat(item.id)}
                        </Link>
                        <ClipboardButton text={item.id} />
                    </td>
                    <td>
                        {moment(new Date(item.createdTime)).format(
                            DATE_FORMAT
                        )}
                        &nbsp;&nbsp;
                        {moment(new Date(item.createdTime)).format('HH:mm')}
                    </td>
                    <td>
                        {moment(new Date(item.lastUpdated)).format(
                            DATE_FORMAT
                        )}
                        &nbsp;&nbsp;
                        {moment(new Date(item.lastUpdated)).format('HH:mm')}
                    </td>
                    <td>{item.name}</td>
                    <td>
                        <WorkflowStatus status={item.status} />
                    </td>
                </tr>
            ))}
        </NewCustomTable>
    );
}

class WorkflowListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: mockData
        };
    }

    handleAdd = () => {
        // TODO fix after added api
        this.props.history.push(`/workflow/dfgsdfgdf`);
    };

    render() {
        const { data } = this.state;

        return (
            <div className="page-content automation-page">
                <MetaTags>
                    <title>{i18n.t('workflow.workflow')} - {process.env.REACT_APP_APP_NAME}</title>
                </MetaTags>

                <Container fluid>
                    <button
                        className="btn btn-rounded btn-primary app-btn-only-img add-button"
                        onClick={this.handleAdd}
                    >
                        <img src={close_2} alt="" />
                    </button>
                    <Breadcrumb breadcrumbItem={i18n.t('workflow.workflow')} />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <WorkflowTable list={data.list} />
                                </CardBody>
                            </Card>

                            {data.pages > 1 && (
                                <CustomPagination
                                    key={'workflow'}
                                    pageCount={data.pages}
                                    activePage={data.page}
                                    onChange={() => {}}
                                />
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withRouter(WorkflowListPage);
